/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { NzbnCompanyResponseBaseResponse as ModelsCustomerNzbnCompanyResponseBaseResponse } from '../models/Models/Customer/nzbn-company-response-base-response';
import { NzbnCompanyResponseListBaseResponse as ModelsCustomerNzbnCompanyResponseListBaseResponse } from '../models/Models/Customer/nzbn-company-response-list-base-response';
import { v4CompaniesGet$Json } from '../fn/companies/v-4-companies-get-json';
import { V4CompaniesGet$Json$Params } from '../fn/companies/v-4-companies-get-json';
import { v4CompaniesGet$Plain } from '../fn/companies/v-4-companies-get-plain';
import { V4CompaniesGet$Plain$Params } from '../fn/companies/v-4-companies-get-plain';
import { v4CompaniesGet$Xml } from '../fn/companies/v-4-companies-get-xml';
import { V4CompaniesGet$Xml$Params } from '../fn/companies/v-4-companies-get-xml';
import { v4CompaniesNzbnGet$Json } from '../fn/companies/v-4-companies-nzbn-get-json';
import { V4CompaniesNzbnGet$Json$Params } from '../fn/companies/v-4-companies-nzbn-get-json';
import { v4CompaniesNzbnGet$Plain } from '../fn/companies/v-4-companies-nzbn-get-plain';
import { V4CompaniesNzbnGet$Plain$Params } from '../fn/companies/v-4-companies-nzbn-get-plain';
import { v4CompaniesNzbnGet$Xml } from '../fn/companies/v-4-companies-nzbn-get-xml';
import { V4CompaniesNzbnGet$Xml$Params } from '../fn/companies/v-4-companies-nzbn-get-xml';

@Injectable({ providedIn: 'root' })
export class CompaniesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4CompaniesGet()` */
  static readonly V4CompaniesGetPath = '/v4/companies';

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CompaniesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CompaniesGet$Plain$Response(params?: V4CompaniesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>> {
    return v4CompaniesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CompaniesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CompaniesGet$Plain(params?: V4CompaniesGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerNzbnCompanyResponseBaseResponse> {
    return this.v4CompaniesGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>): ModelsCustomerNzbnCompanyResponseBaseResponse => r.body)
    );
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CompaniesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CompaniesGet$Json$Response(params?: V4CompaniesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>> {
    return v4CompaniesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CompaniesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CompaniesGet$Json(params?: V4CompaniesGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerNzbnCompanyResponseBaseResponse> {
    return this.v4CompaniesGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>): ModelsCustomerNzbnCompanyResponseBaseResponse => r.body)
    );
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CompaniesGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CompaniesGet$Xml$Response(params?: V4CompaniesGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>> {
    return v4CompaniesGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets address starting with the input string.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CompaniesGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CompaniesGet$Xml(params?: V4CompaniesGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerNzbnCompanyResponseBaseResponse> {
    return this.v4CompaniesGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerNzbnCompanyResponseBaseResponse>): ModelsCustomerNzbnCompanyResponseBaseResponse => r.body)
    );
  }

  /** Path part for operation `v4CompaniesNzbnGet()` */
  static readonly V4CompaniesNzbnGetPath = '/v4/companies/{nzbn}';

  /**
   * DTOCompanyAutocompleteDetails.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CompaniesNzbnGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CompaniesNzbnGet$Plain$Response(params: V4CompaniesNzbnGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseListBaseResponse>> {
    return v4CompaniesNzbnGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * DTOCompanyAutocompleteDetails.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CompaniesNzbnGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CompaniesNzbnGet$Plain(params: V4CompaniesNzbnGet$Plain$Params, context?: HttpContext): Observable<ModelsCustomerNzbnCompanyResponseListBaseResponse> {
    return this.v4CompaniesNzbnGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerNzbnCompanyResponseListBaseResponse>): ModelsCustomerNzbnCompanyResponseListBaseResponse => r.body)
    );
  }

  /**
   * DTOCompanyAutocompleteDetails.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CompaniesNzbnGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CompaniesNzbnGet$Json$Response(params: V4CompaniesNzbnGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseListBaseResponse>> {
    return v4CompaniesNzbnGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * DTOCompanyAutocompleteDetails.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CompaniesNzbnGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CompaniesNzbnGet$Json(params: V4CompaniesNzbnGet$Json$Params, context?: HttpContext): Observable<ModelsCustomerNzbnCompanyResponseListBaseResponse> {
    return this.v4CompaniesNzbnGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerNzbnCompanyResponseListBaseResponse>): ModelsCustomerNzbnCompanyResponseListBaseResponse => r.body)
    );
  }

  /**
   * DTOCompanyAutocompleteDetails.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4CompaniesNzbnGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CompaniesNzbnGet$Xml$Response(params: V4CompaniesNzbnGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerNzbnCompanyResponseListBaseResponse>> {
    return v4CompaniesNzbnGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * DTOCompanyAutocompleteDetails.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4CompaniesNzbnGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4CompaniesNzbnGet$Xml(params: V4CompaniesNzbnGet$Xml$Params, context?: HttpContext): Observable<ModelsCustomerNzbnCompanyResponseListBaseResponse> {
    return this.v4CompaniesNzbnGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsCustomerNzbnCompanyResponseListBaseResponse>): ModelsCustomerNzbnCompanyResponseListBaseResponse => r.body)
    );
  }

}
